import type { FormInstance }   from 'antd';
import React                   from 'react';
import { observer }            from 'mobx-react';
import { Col }                 from 'antd';
import { Divider }             from 'antd';
import { Form }                from 'antd';
import { message }             from 'antd';
import Row                     from 'components/App/Row';
import { InputNumber }         from 'antd';
import { DatePicker }          from 'antd';
import { Button }              from 'antd';
import { Input }               from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import { PlusOutlined }        from '@ant-design/icons';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import { ApiCollection }       from 'collections/ApiCollection';
import DemandTypeModel         from 'models/DemandTypeModel';
import Select                  from 'components/App/IntlSelect';
import DemandConfigModel       from 'models/DemandConfigModel';
import handleApiError          from 'utils/handleApiError';
import type { RefObject }      from 'react';
import ShowModel               from 'models/ShowModel';
import { AppFormComponent }    from 'components/App/AppForm';
import { messageSuccessIntl }  from 'utils/messageIntl';
import { messageErrorIntl }    from 'utils/messageIntl';

const { Option } = Select;

let id = 0;

const specialHandleFormError = (error: any, form: FormInstance | null, current: any) => {
  const data = error.connectorError?.response?.data;

  if (data?.violations) {
    const errors: Record<string, any> = {};
    const fieldsValue = form?.getFieldsValue() || {};

    data.violations.forEach((violation: any) => {
      if (!violation.propertyPath || !fieldsValue[violation.propertyPath]) {
        message.error(
          (violation.propertyPath ? `${violation.propertyPath} : ` : '') + violation.message,
        );
      } else {
        if (!errors[violation.propertyPath]) {
          errors[violation.propertyPath] = [];
        }

        if (!errors[violation.propertyPath][current]) {
          errors[violation.propertyPath][current] = {
            errors: [],
            value: fieldsValue[violation.propertyPath], // if needed
          };
        }

        errors[violation.propertyPath][current].errors.push(violation.message);
      }
    });

    const errorsAsArray: any[] = [];
    Object.keys(errors).forEach(errorKey => {
      const entries = errors[errorKey];
      Object.keys(entries).forEach(entryKey => {
        errorsAsArray.push({
          errors: entries[entryKey].errors,
          name: [errorKey, parseInt(entryKey)],
        });
      });
    });

    // EXEMPLE
    // form.setFields( [
    //   {
    //     name: ['demandsBefore', 0],
    //     errors: ['erreur'],
    //   },
    // ]);

    form?.setFields(errorsAsArray);
  } else if (data?.['hydra:description']) {
    message.error(error.connectorError.response.data['hydra:description']);
  } else {
    messageErrorIntl(`Une erreur s'est produite.`);
  }
};

interface DemandConfigsFormProps {
  collection: ApiCollection<DemandConfigModel>;
  onSuccess: () => void;
  show: ShowModel;
}

interface DemandConfigsFormState {
  demandTypesSelected: any[];
  keys: any[];
}

@observer
class DemandConfigsForm extends AppFormComponent<DemandConfigsFormProps> {
  public demandTypeCollection = new ApiCollection(DemandTypeModel);

  public formRef: RefObject<FormInstance> = React.createRef<FormInstance>();

  public state: DemandConfigsFormState = {
    demandTypesSelected: [],
    keys: [],
  };

  public componentDidMount() {
    const { collection } = this.props;

    const fieldsValue = collection.reduce(
      (carry: any, current: DemandConfigModel) => {
        carry.keys.push(carry.keys.length);
        carry.dType.push(current.demandType);
        carry.demandsAfter.push(current.demandsAfter ? current.demandsAfterDate : undefined);
        carry.demandsBefore.push(current.demandsBefore ? current.demandsBeforeDate : undefined);
        carry.surfaceMin.push(current.surfaceMin);
        carry.id.push(current.id);

        id++;

        return carry;
      },
      {
        demandsAfter: [],
        demandsBefore: [],
        dType: [],
        id: [],
        keys: [],
        surfaceMin: [],
      },
    );

    this.setState(
      {
        demandTypesSelected: fieldsValue.dType,
        keys: fieldsValue.keys,
      },
      () => this.formRef.current?.setFieldsValue(fieldsValue),
    );

    this.demandTypeCollection.list();
  }

  public render() {
    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        sm: { offset: 6, span: 12 },
        xs: { md: 24, offset: 0 },
      },
    };

    const formItems = this.state.keys.map(k => (
      <React.Fragment key={k}>
        <div style={{ display: 'none' }}>
          <Form.Item
            name={['id', k]}
            // help={getFieldError(`id[${k}]`) || ''}
            // validateStatus={getFieldError(`id[${k}]`) ? 'error' : ''}
          >
            <Input />
          </Form.Item>
        </div>

        <Row>
          <Col span={22}>
            <Row>
              <Col md={12} sm={24}>
                <Form.Item
                  // help={getFieldError(`dType[${k}]`) || ''}
                  label={<FormattedMessageWrapper id="Type de demande" />}
                  labelCol={{ span: 24 }}
                  // validateStatus={getFieldError(`dType[${k}]`) ? 'error' : ''}
                  name={['dType', k]}
                >
                  <Select
                    onChange={(value: any) => {
                      this.setState((previousState: DemandConfigsFormState) => {
                        const newDemandTypesSelected = [...previousState.demandTypesSelected];
                        newDemandTypesSelected[k] = value;
                        return {
                          demandTypesSelected: newDemandTypesSelected,
                        };
                      });
                    }}
                    style={{ width: '100%' }}
                  >
                    {this.demandTypeCollection.map((demandType: DemandTypeModel) => (
                      <Option
                        disabled={
                          !!this.state.demandTypesSelected &&
                          !!this.state.demandTypesSelected.find(dt => dt === demandType.get('@id'))
                        }
                        key={demandType.id}
                        value={demandType.get('@id')}
                      >
                        {demandType.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={6} sm={24}>
                <Form.Item
                  // help={getFieldError(`demandsAfter[${k}]`) || ''}
                  label={<FormattedMessageWrapper id="A partir du" />}
                  labelCol={{ span: 24 }}
                  // validateStatus={
                  //   getFieldError(`demandsAfter[${k}]`) ? 'error' : ''
                  // }
                  name={['demandsAfter', k]}
                >
                  <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                </Form.Item>
              </Col>

              <Col md={6} sm={24}>
                <Form.Item
                  // help={getFieldError(`demandsBefore[${k}]`) || ''}
                  label={<FormattedMessageWrapper id="Jusqu'au" />}
                  labelCol={{ span: 24 }}
                  // validateStatus={
                  //   getFieldError(`demandsBefore[${k}]`) ? 'error' : ''
                  // }
                  name={['demandsBefore', k]}
                >
                  <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                </Form.Item>
              </Col>

              <Col md={6} sm={24}>
                <Form.Item
                  // help={getFieldError(`surfaceMin[${k}]`) || ''}
                  label={
                    <>
                      <FormattedMessageWrapper id="Surface min" />
                      &nbsp;(
                      <var>
                        m<sup>2</sup>
                      </var>
                      )
                    </>
                  }
                  labelCol={{ span: 24 }}
                  // validateStatus={getFieldError(`surfaceMin[${k}]`) ? 'error' : ''}
                  name={['surfaceMin', k]}
                >
                  <InputNumber style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={2}>
            <div className="ant-row ant-form-item">
              <div style={{ height: 40 }} />
              <div className="ant-col ant-form-item-control-wrapper">
                <div className="ant-form-item-control">
                  <span className="ant-form-item-children">
                    <MinusCircleOutlined
                      className="dynamic-delete-button"
                      onClick={() => this.remove(k)}
                    />
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Divider />
      </React.Fragment>
    ));

    return (
      <Form
        initialValues={{
          keys: [],
        }}
        ref={this.formRef}
      >
        <Form.Item name="keys" style={{ display: 'none' }} />

        {formItems}

        <Form.Item {...formItemLayoutWithOutLabel}>
          <Button
            icon={<PlusOutlined />}
            onClick={this.add}
            style={{
              alignItems: 'center',
              display: 'flex',
              gap: '8px',
              justifyContent: 'center',
              width: '100%',
            }}
            type="dashed"
          >
            <FormattedMessageWrapper id="Activer un type de demande" />
          </Button>
        </Form.Item>
      </Form>
    );
  }

  public submit = async () => {
    const {
      onSuccess,
      show,
    } = this.props;

    const values = await this.formRef.current?.validateFields();

    let current;

    try {
      for (const i of this.state.keys) {
        // for (let i = 0; i < values.keys.length; i += 1) {
        current = i;

        const demandConfig = new DemandConfigModel();
        demandConfig.setId(values.id[i]);
        await demandConfig.patch({
          demandsAfter: values.demandsAfter[i] ? values.demandsAfter[i].format('YYYY-MM-DD') : null,
          demandsBefore: values.demandsBefore[i]
            ? values.demandsBefore[i].format('YYYY-MM-DD')
            : null,
          demandType: values.dType[i],
          show: show.get('@id'),
          surfaceMin: values.surfaceMin[i],
        });
      }

      messageSuccessIntl("Enregistrement réussi !");

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      specialHandleFormError(error, this.formRef.current, current);
    }
  };

  private add = () => {
    // can use data-binding to get
    const keys = this.formRef.current?.getFieldValue('keys');

    const nextKeys = keys.concat(id++);

    this.setState(
      {
        keys: nextKeys,
      },
      () => {
        // can use data-binding to set
        // important! notify form to detect changes
        this.formRef.current?.setFieldsValue({
          keys: nextKeys,
        });
      },
    );
  };

  private remove = async (k: string) => {
    // can use data-binding to get
    const keys = this.formRef.current?.getFieldValue('keys');

    const demandConfigId = this.formRef.current?.getFieldValue(['id', k]);

    if (demandConfigId) {
      const demandConfig = new DemandConfigModel();
      demandConfig.setId(demandConfigId);

      try {
        await demandConfig.destroy();
      } catch (error) {
        handleApiError(error);
        return;
      }
    }

    const newKeys = keys.filter((key: string) => key !== k);

    this.setState(
      {
        keys: newKeys,
      },
      () => {
        // can use data-binding to set
        this.formRef.current?.setFieldsValue({
          keys: newKeys,
        });
      },
    );
  };
}

export default DemandConfigsForm;
